import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

// <div [innerHtml]="thread.body | raw"></div>

@Pipe({
    name: 'raw',
    standalone: false
})
export class RawPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);


  transform(value: string) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
